import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '分类浏览',
    links: [
      { label: '品牌故事', href: '/category/brand-story' },
      { label: '匠心工艺', href: '/category/craftsmanship' },
      { label: '生活美学', href: '/category/lifestyle' },
      { label: '文化传承', href: '/category/cultural-heritage' },
      { label: '产品体验', href: '/category/products' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '历史沿革', href: '/about#history' },
      { label: '口碑声誉', href: '/about#testimonials' },
      { label: '联系我们', href: '/about#contact' },
    ],
  },
  {
    title: '了解更多',
    links: [
      { label: '常见问题', href: '/#faq' },
      { label: '匠心之道', href: '/article/article-2' },
      { label: '家主访谈', href: '/article/article-8' },
      { label: '品牌国际化', href: '/article/article-6' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand info */}
          <div>
            <Link to="/" className="text-xl font-heading font-semibold text-foreground-900">
              高柳家
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              始于1750年，传承九代，以匠心与美学诠释生活的温度与品质。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 transition-colors duration-200" aria-label="Instagram">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 transition-colors duration-200" aria-label="YouTube">
                <i className="ri-youtube-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Link columns */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between mt-12 pt-6 border-t border-secondary-200/60">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 高柳家 Takayanagi Family. All rights reserved.
          </p>
          <div className="flex items-center gap-4 mt-3 sm:mt-0">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}